import { useTranslation } from "react-i18next";

import { IntakeFlowStep } from "../types/interviewSession";
import { FLOW_STEP_MAP } from "../mocks/flowSteps";
import { useIntakeProfile } from "../context/IntakeProfileContext";

export function useIntakeCopy() {
  const { t } = useTranslation();
  const { journey } = useIntakeProfile();

  const progressLabel = (step: number, total = 5) =>
    t("intake.progress_step", { step, total });

  const skipLabel = (current: number, total: number) =>
    t("intake.skip_count", { current, total });

  const flowText = (stepId: string) => {
    const journeyKey = `intake.flow.${journey}.${stepId}`;
    const defaultKey = `intake.flow.${stepId}`;
    return {
      headline: t(`${journeyKey}.headline`, {
        defaultValue: t(`${defaultKey}.headline`),
      }),
      body: t(`${journeyKey}.body`, {
        defaultValue: t(`${defaultKey}.body`),
      }),
    };
  };

  const primaryLabel = (step: IntakeFlowStep) => {
    if (step.type === "intro") return t("intake.done");
    if (step.type === "track-choice") return t("intake.next");
    return t("intake.next");
  };

  const trackOptionLabel = (id: "personal" | "business") =>
    t(`intake.flow.track-choice.option_${id}`);

  return {
    t,
    progressLabel,
    skipLabel,
    flowText,
    primaryLabel,
    trackOptionLabel,
    step: (id: string) => FLOW_STEP_MAP[id],
  };
}
